module.exports = __webpack_public_path__ + "static/img/question.0241aff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/question.png
// module id = apGm
// module chunks = 7